import { FC, useState } from "react";
import { Modal } from "../../../components/common/Modal/Modal";
import { ModalBody } from "../../../components/common/Modal/ModalBody";
import { CustomTabPanel } from "../../../components/common/CustomTabPanel/CustomTabPanel";
import { Box, Grid, IconButton, Paper, Tab, Tabs, Typography, Button, Divider, Table, TableBody, TableHead, TableRow, TableCell } from "@mui/material";
import imagen_prueba from "../../../assets/image/imagen_puerta.png";
import { styled } from '@mui/system';

import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import categoria_prueba from '../../../assets/image/categoria_prueba.png';

const tabData = [
    {
        label: 'Imagen 1',
        image: categoria_prueba,
    },
    {
        label: 'Imagen 2',
        image: categoria_prueba,
    },
    {
        label: 'Imagen 3',
        image: categoria_prueba,
    },
]

// const product = {
//     name: 'Puera delantera derecha',
//     model: 'NISSAN V16 1990-2012',
//     price: '$ 200.000',
//     description: 'Puerta de auto',
//     type: 'product terminado',
//     category: 'Repuestos',
//     subcategoria: 'Carrocería',
//     um: 'Unidades',
//     imagenes: tabData
// }

const products = [
    { id: 1, name: 'Puerta delantera derecha', model: 'NISSAN V16 1990-2012', price: '$127.350', price_discount: '$110.500', img: imagen_prueba },
    { id: 2, name: 'Puerta delantera derecha', model: 'NISSAN V16 1990-2012', price: '$127.350', price_discount: '$110.500', img: imagen_prueba },
    { id: 3, name: 'Puerta delantera derecha', model: 'NISSAN V16 1990-2012', price: '$127.350', price_discount: '$110.500', img: imagen_prueba },
    { id: 4, name: 'Puerta delantera derecha', model: 'NISSAN V16 1990-2012', price: '$127.350', price_discount: '$110.500', img: imagen_prueba },
    { id: 5, name: 'Puerta delantera derecha', model: 'NISSAN V16 1990-2012', price: '$127.350', price_discount: '$110.500', img: imagen_prueba },
    { id: 6, name: 'Puerta delantera derecha', model: 'NISSAN V16 1990-2012', price: '$127.350', price_discount: '$110.500', img: imagen_prueba },
]


interface SearcherKFCProductModalProps {
    open: boolean
    closeModal: () => void
    product: any
    handleSelectProduct: (idproduct: number, quantity?: number) => Promise<void>
}

const MyTabs = styled(Tabs)({
    backgroundColor: '#91CBF9',
    color: '#fff',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
    '& .MuiTabs-indicator': {
        backgroundColor: '#fff',
        height: '3px',
    },
});

const MyTab = styled(Tab)({
    '&.Mui-selected': {
        fontWeight: 'bold',
    },
    minWidth: '150px', // Establecer un ancho mínimo para las pestañas
});
const StyledTableCell = ({ children, ...props }) => (
    <TableCell {...props}>
        <Typography variant="body1">{children}</Typography>
    </TableCell>
);

const StyledTableRow = ({ children }) => (
    <TableRow sx={{ '&:nth-of-type(odd)': { backgroundColor: '#f8f9f9' } }}>
        {children}
    </TableRow>
);

export const SearcherKFCProductModal: FC<SearcherKFCProductModalProps> = (props): JSX.Element | any => {
    const { open, closeModal, product, handleSelectProduct } = props

    const [quantity, setQuantity] = useState<number>(1)
    const [panel, setPanel] = useState<number>(0)
    const [value, setValue] = useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setPanel(newValue)
    }


    const handleChange2 = (event, newValue) => {
        setValue(newValue);
    }

    return (
        <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick size="sm">
            <ModalBody>
                <Grid item container justifyContent="flex-end" xs={12}>
                    <IconButton onClick={() => closeModal()}>
                        <CloseIcon fontSize="medium" />
                    </IconButton>
                </Grid>
                <Grid>
                    {/* Pestañas */}
                    <MyTabs value={panel} onChange={handleChange} variant="fullWidth">
                        <MyTab label="Datos generales" />
                        <MyTab label="Atributos" />
                        <MyTab label="Usos" />
                    </MyTabs>

                    {/* Pestaña datos generales */}
                    <CustomTabPanel value={panel} index={0}>
                        <Grid container spacing={2} sx={{ height: '350px', marginTop: '10px', padding: '20px' }}>
                            {/* Imagen */}
                            <Grid item xs={12} md={6}>
                                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                    <img src={tabData[value].image} alt={tabData[value].label} style={{ maxWidth: '175px', maxHeight: '175px' }} />
                                </Box>
                                <Tabs
                                    value={value}
                                    onChange={handleChange2}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    centered
                                    variant="scrollable"
                                    scrollButtons="auto"
                                    aria-label="scrollable auto tabs example"
                                    sx={{ width: '250px', margin: '0 auto', marginTop: '20px' }}
                                >
                                    {tabData.map((tab, index) => (
                                        <Tab key={index} icon={<img src={tab.image} alt={tab.label} width="50" />} />
                                    ))}
                                </Tabs>
                            </Grid>

                            {/* Descripción */}
                            <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column' }}>
                                <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: '5px' }}>{product.name_product.toUpperCase()}</Typography>
                                <Typography variant="body1" sx={{ marginBottom: '5px' }}>{product.model}</Typography>
                                <Typography variant="body2" sx={{ fontWeight: 'bold', marginBottom: '5px' }}>$ {product.price}</Typography>

                                <Typography variant="body2" sx={{ fontWeight: 'bold', marginBottom: '5px' }}>Descripción:</Typography>
                                <Typography variant="body2" sx={{ marginBottom: '5px' }}>{product.description}</Typography>
                                <Typography variant="body2" sx={{ fontWeight: 'bold', marginBottom: '5px' }}>Categoría:</Typography>
                                <Typography variant="body2" sx={{ marginBottom: '5px' }}>{product.category_product}</Typography>
                                <Typography variant="body2" sx={{ fontWeight: 'bold', marginBottom: '5px' }}>Subcategoría:</Typography>
                                <Typography variant="body2" sx={{ marginBottom: '5px' }}>{product.subcategory_product}</Typography>
                                <Typography variant="body2" sx={{ fontWeight: 'bold', marginBottom: '5px' }}>UM:</Typography>
                                <Typography variant="body2" sx={{ marginBottom: '5px' }}>{product.unitmeasure_product}</Typography>

                                <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                                    <Typography variant="body2" sx={{ fontWeight: 'bold', marginRight: '15px' }}>Cantidad:</Typography>
                                    <Grid container alignItems="center" spacing={1}>
                                        <IconButton
                                            sx={{ background: '#516E80', width: '30px', height: '30px', marginRight: '5px', '&:hover': { background: '#516E80' } }}
                                            onClick={() => setQuantity(quantity - 1)}
                                        >
                                            <RemoveIcon fontSize="small" sx={{ color: '#ffffff' }} />
                                        </IconButton>
                                        <Typography variant="body2">{quantity}</Typography>
                                        <IconButton
                                            sx={{ background: '#516E80', width: '30px', height: '30px', marginLeft: '5px', '&:hover': { background: '#516E80' } }}
                                            onClick={() => setQuantity(quantity + 1)}
                                        >
                                            <AddIcon fontSize="small" sx={{ color: '#ffffff' }} />
                                        </IconButton>
                                    </Grid>
                                </Box>

                                <Button
                                    onClick={() => handleSelectProduct(product.idproduct, quantity)}
                                    sx={{ backgroundColor: '#91CBF9', borderRadius: '20px', color: '#fff', marginTop: '10px', width: '100%', "&:hover": { color: 'black', backgroundColor: "#91CBF9" } }}
                                >
                                    Añadir al carrito
                                </Button>
                            </Grid>
                        </Grid>
                    </CustomTabPanel>

                    {/* Pestaña atributos */}
                    <CustomTabPanel value={panel} index={1}>
                        <Grid container sx={{ height: '350px', marginTop: '10px', padding: '20px' }}>
                            <Table>
                                <TableBody>
                                    <StyledTableRow>
                                        <StyledTableCell fontWeight="bold">Marca</StyledTableCell>
                                        <StyledTableCell>{product.trade}</StyledTableCell>
                                    </StyledTableRow>
                                    <StyledTableRow>
                                        <StyledTableCell fontWeight="bold">Modelo</StyledTableCell>
                                        <StyledTableCell>{product.model}</StyledTableCell>
                                    </StyledTableRow>
                                    <StyledTableRow>
                                        <StyledTableCell fontWeight="bold">Categoría</StyledTableCell>
                                        <StyledTableCell>{product.trade}</StyledTableCell>
                                    </StyledTableRow>
                                    <StyledTableRow>
                                        <StyledTableCell fontWeight="bold">Garantía</StyledTableCell>
                                        <StyledTableCell>Un año</StyledTableCell>
                                    </StyledTableRow>
                                    <StyledTableRow>
                                        <StyledTableCell fontWeight="bold">Medidas</StyledTableCell>
                                        <StyledTableCell>150cm x 100cm</StyledTableCell>
                                    </StyledTableRow>
                                    <StyledTableRow>
                                        <StyledTableCell fontWeight="bold">Peso</StyledTableCell>
                                        <StyledTableCell>12.4 Kg</StyledTableCell>
                                    </StyledTableRow>
                                    <StyledTableRow>
                                        <StyledTableCell fontWeight="bold">Material</StyledTableCell>
                                        <StyledTableCell>Acero</StyledTableCell>
                                    </StyledTableRow>
                                    <StyledTableRow>
                                        <StyledTableCell fontWeight="bold">Información adicional</StyledTableCell>
                                        <StyledTableCell>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Consectetur molestias ratione aut animi ex magnam velit, quis, dicta quia natus ipsam corporis soluta aspernatur facere debitis laboriosam? Officia, pariatur quos.</StyledTableCell>
                                    </StyledTableRow>
                                </TableBody>
                            </Table>
                        </Grid>
                    </CustomTabPanel>

                    {/* Pestaña usos */}
                    <CustomTabPanel value={panel} index={2}>
                        <Grid container sx={{ height: '350px', marginTop: '10px', padding: '20px' }}>
                            <Table>
                                <TableBody>
                                    <StyledTableRow>
                                        <StyledTableCell fontWeight="bold">Uso específico</StyledTableCell>
                                        <StyledTableCell>Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta, iure rem? Quam, inventore. Eos, sit. Commodi repellat voluptatibus quasi aut unde atque, ipsam in voluptas laboriosam id fugiat magnam. Ipsam?</StyledTableCell>
                                    </StyledTableRow>
                                    <StyledTableRow>
                                        <StyledTableCell fontWeight="bold">Marcas de uso</StyledTableCell>
                                        <StyledTableCell>NISSAN</StyledTableCell>
                                    </StyledTableRow>
                                    <StyledTableRow>
                                        <StyledTableCell fontWeight="bold">Modelos compatibles</StyledTableCell>
                                        <StyledTableCell>NISSAN v16-2001 | NISSAN v15-2005</StyledTableCell>
                                    </StyledTableRow>
                                </TableBody>
                            </Table>
                        </Grid>
                    </CustomTabPanel>

                    {/* Pestaña complementos */}
                    {/* <CustomTabPanel value={panel} index={3}>
                        <Grid container spacing={2} sx={{ height: '410px' }}>
                            <Grid item xs={12}>
                                <Typography sx={{ marginRight: 'auto' }}>Otros products que pueden interesar según tu compra</Typography>
                            </Grid>
                            <Grid item style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
                                {
                                    products.map((product, index) => (
                                        <Box key={index} style={{ display: 'inline-block', margin: '5px', padding: '5px' }}>
                                            <Grid item>
                                                <img src={product.img} alt={product.name} />
                                            </Grid>
                                            <Divider sx={{ margin: '10px 0px' }} />
                                            <Grid item display="flex" justifyContent="center">
                                                <Typography sx={{ color: '#CA0000', fontWeight: 'bolder', margin: '0px 5px' }}>{product.price}</Typography>
                                                <Typography sx={{ color: '#000000', textDecoration: 'line-through', margin: '0px 5px' }}>{product.price_discount}</Typography>
                                            </Grid>
                                            <Grid item display="flex" justifyContent="center">
                                                <Typography sx={{ color: '#000000', fontWeight: 'bolder' }}>{product.name}</Typography>
                                            </Grid>
                                            <Grid item display="flex" justifyContent="center">
                                                <Typography>{product.model}</Typography>
                                            </Grid>
                                            <Grid item display="flex" justifyContent="center" sx={{ marginTop: '10px' }}>
                                                <Button
                                                    sx={{
                                                        backgroundColor: '#516E80',
                                                        borderRadius: '10px',
                                                        color: '#ffffff',
                                                        height: '25px',
                                                        padding: '6px 16px',
                                                        textTransform: 'none',
                                                        width: 150,
                                                        "&:hover": { backgroundColor: "#516E80" }
                                                    }}
                                                >
                                                    Añadir al carrito
                                                </Button>
                                            </Grid>
                                        </Box>
                                    ))
                                }
                            </Grid>
                        </Grid>
                    </CustomTabPanel> */}
                </Grid>
            </ModalBody>
        </Modal>
    )
}